var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.9,
    height: 14,
    viewBox: "0 0 11.9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "content_copy_FILL1_wght400_GRAD0_opsz24",
    d: "M124.2-868.8a1.348,1.348,0,0,1-.989-.411,1.348,1.348,0,0,1-.411-.989v-8.4a1.348,1.348,0,0,1,.411-.989A1.348,1.348,0,0,1,124.2-880h6.3a1.348,1.348,0,0,1,.989.411,1.348,1.348,0,0,1,.411.989v8.4a1.348,1.348,0,0,1-.411.989,1.348,1.348,0,0,1-.989.411Zm-2.8,2.8a1.348,1.348,0,0,1-.989-.411A1.348,1.348,0,0,1,120-867.4v-9.8h1.4v9.8h7.7v1.4Z",
    transform: "translate(-120 880)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.82161a7fb02b89c2957061ddfd16ec1f.svg";
export { ForwardRef as ReactComponent };